import { render, staticRenderFns } from "./answerParty.vue?vue&type=template&id=4aa5d68a&scoped=true&"
import script from "./answerParty.vue?vue&type=script&lang=js&"
export * from "./answerParty.vue?vue&type=script&lang=js&"
import style0 from "./answerParty.vue?vue&type=style&index=0&id=4aa5d68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5d68a",
  null
  
)

export default component.exports